import { useCallback } from 'react';
import { Logger } from '@saviynt/common';

import { useDisableServiceIdMutation } from '../data-layer/serviceIdentityApi';

const useDisableServiceId = (serviceId: number | undefined) => {
  // API hooks
  const [executeDisableAction, { isLoading: isActionLoading }] =
    useDisableServiceIdMutation();

  const getActionLabel = <T extends boolean>(isDelete: T, isEnabled: T) => {
    if (isDelete) {
      return 'delete';
    }

    if (isEnabled) {
      return 'enable';
    }

    return 'disable';
  };

  const handleDisableAction = useCallback(
    async (isDelete = false, isEnable = false) => {
      try {
        if (!serviceId) {
          throw new Error('No service ID provided');
        }

        const controller = executeDisableAction({
          serviceId,
          action: getActionLabel(isDelete, isEnable),
        });

        const response = await controller.unwrap();

        return response;
      } catch (error) {
        Logger.log('Failed to execute action ', error);

        return 'Failed to execute action';
      }
    },
    [executeDisableAction, serviceId]
  );

  return {
    handleDisableAction,
    isActionLoading,
  };
};

// eslint-disable-next-line import/prefer-default-export
export { useDisableServiceId };
